import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FaCaretDown, FaSlidersH } from "react-icons/fa";
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import PlaceHolder from "../../../../assets/images/Placeholder.png";
import { FadeLoader } from "react-spinners";
import MsgModal from "../../modals/MsgModal";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardText,
  Button,
  Container,
} from "reactstrap";
import "../LcaCards.css"; // Import your custom CSS file
import moment from "moment-timezone";
import "moment-timezone/builds/moment-timezone-with-data";
import { fetchBWV, fetchUserDetails } from "../../Data";
import CarouselComponent from "../BizzList";
import GitHubForkRibbon from "react-github-fork-ribbon";
import BwvBox from "../BwvBox";
import {
  setIsMsgModalOpen,
  setSampleAd,
} from "../../../../redux/slices/SearchBarSlice";

const BwvCards2 = ({ allProducts, setLoading, carouselData }) => {
  const location = useLocation();
  const islogin = useSelector((state) => state.user.isLogin);
  const userdata = useSelector((state) => state.user);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { bwvLoading } = useSelector((state) => state.lcAds);
  const { sampleAd, isMsgModalOpen } = useSelector((state) => state.searchBar);
  const closeModal = () => {
    dispatch(setSampleAd(null));
    dispatch(setIsMsgModalOpen(false));
  };

  if (!allProducts) {
    <p>No Ads</p>;
    return;
  }

  if (!allProducts.length) {
    return <div>No products available</div>; // Fallback UI
  }
  //   Verified & Trusted should be on top
  let sortverified = allProducts.sort((a, b) => {
    if (a.caIdStatus === 100 && b.sortverified !== 100) {
      return -1; // a comes before b
    } else if (a.caIdStatus !== 100 && b.caIdStatus === 100) {
      return 1; // b comes before a
    } else {
      return 0; // a and b are equal
    }
  });

  if (bwvLoading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "40vh" }}
      >
        <FadeLoader color={"#36D7B7"} />
      </div>
    );
  }
  return (
    <Container>
      {sortverified && sortverified.length > 0 ? (
        <>
          {sortverified.map((ad, index) => (
            <div key={ad.Id}>
              <p className="mb-0" style={{ fontSize: "medium" }}>
                {ad?.FullName}
              </p>
              <BwvBox ad={ad} />
              {index === 2 && carouselData.row1.length > 0 && (
                <Card className="my-2 mb-0 border-white">
                  <CarouselComponent items={carouselData.row1} />
                </Card>
              )}
              {index === 5 && carouselData.row2.length > 0 && (
                <Card className="my-2 mb-0 border-white">
                  <CarouselComponent items={carouselData.row2} />
                </Card>
              )}
              {index === 8 && carouselData.row3.length > 0 && (
                <Card className="my-2 mb-0 border-white">
                  <CarouselComponent items={carouselData.row3} />
                </Card>
              )}
            </div>
          ))}
        </>
      ) : (
        <div className="text-center my-5"></div>
        // <div
        //   className="text-center py-5 text-primary"
        //   style={{
        //     display: "flex",
        //     alignItems: "center",
        //     justifyContent: "center",
        //     margin: "50px 0px",
        //   }}
        // >
        //   <p
        //     style={{
        //       display: "flex",
        //       alignItems: "center",
        //       justifyContent: "center",
        //       margin: "10px 0px",
        //       fontSize: "20px",
        //     }}
        //     className="text-center py-5"
        //   >
        //     No cards to display
        //   </p>
        // </div>
      )}

      <MsgModal
        isOpen={isMsgModalOpen}
        closeModal={closeModal}
        selectedCard={sampleAd}
      />
    </Container>
  );
};

export default BwvCards2;
